import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { StyleDeclarationValue, css } from 'aphrodite';
import { Observer, inject, observer } from 'mobx-react';
import * as React from 'react';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';
import { getDefaultDateStringValue, getIndustryName, isTemplateNew } from '../../../../models/UiUtils';
import { IndustryTemplateViewModel } from '../../../../viewmodels/AdminViewModels';
import {
	Dropdown,
	DropdownContent,
	DropdownEllipsisTrigger,
	DropdownItem,
} from '../../../../web/components-v2/Dropdown';
import { DragGripperIcon } from '../../../../web/components/svgs/icons/DragGripperIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps {
	className?: string;
	index: number;
	onClick?(e: React.MouseEvent<HTMLElement>): void;
	onMenuItemClicked?(menuItem: 'edit' | 'archive' | 'delete' | 'publish' | 'copy'): void;
	styles?: StyleDeclarationValue[];
	template: IndustryTemplateViewModel;
	type: 'drafts' | 'archived' | 'published';
}

class _IndustryTemplatesTableRow extends React.Component<IProps> {
	public render() {
		const { type } = this.props;
		return type === 'published' ? this.renderDraggable() : this.renderContent();
	}

	private renderContent(draggableProvided?: DraggableProvided) {
		const { className, styles, template, type, onMenuItemClicked, onClick } = this.props;
		const industriesListStringValue = template.industries.reduce(
			(prev, curr) => `${prev}${prev ? ', ' : ''}${getIndustryName(curr)}`,
			''
		);
		const showMoreActionButton = type !== 'archived' || template.canDelete;
		return (
			<Observer>
				{() => {
					return (
						<div
							className={`${css(styleSheet.container, ...(styles || []))} industry-templates-table-row ${
								className || ''
							}`}
							ref={draggableProvided ? draggableProvided.innerRef : undefined}
							{...(draggableProvided?.draggableProps || {})}
						>
							<div className={css(styleSheet.gripperCol)}>
								{type === 'published' && (
									<span {...(draggableProvided?.dragHandleProps || {})}>
										<DragGripperIcon />
									</span>
								)}
							</div>
							<div className={css(baseStyleSheet.truncateText, styleSheet.nameCol)} title={template.name}>
								<button className={css(styleSheet.nameColButton)} onClick={onClick}>
									<span className={css(baseStyleSheet.truncateText)}>{template.name}</span>
								</button>
								{type === 'published' && isTemplateNew(template) && !!template.name && (
									<span className={css(styleSheet.newItem)}>&nbsp; &nbsp; New</span>
								)}
							</div>
							<div
								className={css(baseStyleSheet.truncateText, styleSheet.industriesCol)}
								title={industriesListStringValue}
							>
								{industriesListStringValue}
							</div>
							<div className={css(styleSheet.creationDateCol)}>{getDefaultDateStringValue(template.creationDate)}</div>
							<div className={css(styleSheet.actionsCol)}>
								{showMoreActionButton ? (
									<Dropdown>
										<DropdownEllipsisTrigger styles={[styleSheet.actionsColMoreButton]} />
										<DropdownContent>
											{type === 'archived' && template.canDelete ? (
												<>
													<DropdownItem onClick={() => onMenuItemClicked('delete')}>Delete</DropdownItem>
												</>
											) : null}
											{type === 'drafts' ? (
												<>
													<DropdownItem onClick={() => onMenuItemClicked('edit')}>Edit</DropdownItem>
													<DropdownItem onClick={() => onMenuItemClicked('publish')}>Publish</DropdownItem>
													{template.canDelete ? (
														<DropdownItem onClick={() => onMenuItemClicked('delete')}>Delete</DropdownItem>
													) : null}
												</>
											) : null}
											{type === 'published' ? (
												<>
													<DropdownItem onClick={() => onMenuItemClicked('edit')}>Edit</DropdownItem>
													<DropdownItem onClick={() => onMenuItemClicked('copy')}>Copy</DropdownItem>
													<DropdownItem onClick={() => onMenuItemClicked('archive')}>Archive</DropdownItem>
													{template.canDelete ? (
														<DropdownItem onClick={() => onMenuItemClicked('delete')}>Delete</DropdownItem>
													) : null}
													<DropdownItem onClick={() => onMenuItemClicked('copy')}>Copy Direct Link</DropdownItem>
												</>
											) : null}
										</DropdownContent>
									</Dropdown>
								) : null}
							</div>
						</div>
					);
				}}
			</Observer>
		);
	}

	private renderDraggable() {
		const { index, template } = this.props;
		return (
			<Draggable disableInteractiveElementBlocking={true} draggableId={template.id} index={index}>
				{(draggableProvided: DraggableProvided) => {
					return this.renderContent(draggableProvided);
				}}
			</Draggable>
		);
	}
}

const IndustryTemplatesTableRowAsObserver = observer(_IndustryTemplatesTableRow);
const IndustryTemplatesTableRowWithContext = inject()(IndustryTemplatesTableRowAsObserver);
export const IndustryTemplatesTableRow = withEventLogging(
	IndustryTemplatesTableRowWithContext,
	'IndustryTemplatesTableRow'
);
